<style lang="scss">
.flex.items-center.imgHover {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100% !important;
  width: 100% !important;
  transform: scale(3.3);
}
.imgHover:hover {
  transition: all 0.4s;
}
.imgHover .vs-avatar--con-img {
  border-radius: 0;
}
// .ag-header-cell-label {
//   justify-content: center;
// }
</style>

<template>
  <div class="flex items-center imgHover">
    <vs-avatar
      :src="params.data.photoUrl"
      class="flex-shrink-0 mr-2"
      size="30px"
      @click="$router.push(url)"
    />
    <router-link
      :to="url"
      @click.stop.prevent
      class="text-inherit hover:text-primary"
    >{{ params.data.path }}</router-link>
  </div>
</template>

<script>
export default {
  name: "CellRendererLink",
  computed: {
    url() {
      return "#";

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    },
  },
};
</script>
